<template>
  <div class="outputTrans">
    <h2>{{outputText}}</h2>
  </div>
</template>

<script>
export default {
  name: 'outputTrans',
  props:["outputText"],   //接收父组件传递的数据
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #outputTrans h2{
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/OutputTrans.vue